import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Usuario } from '../_models/usuario.model';
import { Observable } from 'rxjs';
import { RolUsuario } from '../_models/_enums/rolUsuario.enum';

export enum UsuarioInclude {
  Accesos,
  Asociado,
  Proveedor,
  Favoritos,
  NumeroPedidos,
}

export interface UsuarioParams {
  id?: number;
  ids?: number[];
  nombre?: string;
  includes?: UsuarioInclude[];
  roles?: RolUsuario[];
  correo?: string;
  idProveedor?: number;
  idAsociado?: number;
}

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/Usuario`;

  constructor() {}

  getUsuario(params?: UsuarioParams): Observable<Usuario> {
    const httpParams = new HttpParams({ fromObject: { ...params } });
    return this.http.get<Usuario>(`${this.apiUrl}`, { params: httpParams });
  }

  getUsuarios(params?: UsuarioParams): Observable<Usuario[]> {
    let httpParams = new HttpParams({ fromObject: { ...params } });

    return this.http.get<Usuario[]>(`${this.apiUrl}/lista`, {
      params: httpParams,
    });
  }

  crearUsuario(usuario: Partial<Usuario>) {
    return this.http.post(`${this.apiUrl}`, usuario);
  }

  actualizarUsuario(id: number, usuario: Partial<Usuario>) {
    return this.http.put(`${this.apiUrl}/${id}`, usuario);
  }

  eliminarUsuario(id: number) {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  solicitarRestablecerContrasena(id: number) {
    return this.http.post(`${this.apiUrl}/${id}/restablecer-contrasena`, {});
  }
}
